import React from "react";

export default function DeleteButton({code, deleteVoucher}) {

    return <button className="sp-delete-code" onClick={async () => await deleteVoucher(code)}>Delete</button>;
}